

import styled from 'styled-components';

/**
 * Estilização do componente WrapFilter
 */
 export const ModalBody = styled.div`
  
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  

  .modalBox {
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #000;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 6px;
    padding: 8px;
    box-sizing: border-box;
    outline: 0;      
  }

  .minimize {
    background: none;
    border: none;    
    display: inline;
    width: 27px;
    height: 37px;
    padding-left: 12px;
  }

  .close {
    background: none;
    border: none;    
    display: inline;
    width: 27px;
    height: 37px;
    padding-right: 8px;
  }

  .container-img {    
    position: relative;
  }

  .container-img:hover .container-buttons {    
    display: block;
  }

  .container-buttons {
    float: right;
    position: absolute;   
    right: 0;  
    top: 0; 
    background-color: rgba(0, 0, 0, 0.6);
    width: 55px;
    height: 34px;   
    display: none; 
  }  
`;